"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const with_show_flag_1 = require("./with-show-flag");
exports.useFlagOnError = (flag, error) => {
    const { showFlag } = react_1.useContext(with_show_flag_1.FlagContext);
    react_1.useEffect(() => {
        if (!error) {
            return;
        }
        showFlag({
            title: flag.title,
            message: flag.message,
            type: flag.type || "error"
        });
    }, [error]);
};
